'use strict';

var _get = require('babel-runtime/helpers/get')['default'];

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _response = require('../response');

var _response2 = _interopRequireDefault(_response);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var SuperagentResponse = (function (_ResponseWrapper) {
    _inherits(SuperagentResponse, _ResponseWrapper);

    function SuperagentResponse() {
        _classCallCheck(this, SuperagentResponse);

        _get(Object.getPrototypeOf(SuperagentResponse.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(SuperagentResponse, [{
        key: 'status',
        get: function get() {
            return this.response.status;
        }
    }, {
        key: 'statusType',
        get: function get() {
            return this.response.statusType;
        }
    }, {
        key: 'text',
        get: function get() {
            return this.response.text;
        }
    }, {
        key: 'body',
        get: function get() {
            return this.response.body;
        }
    }]);

    return SuperagentResponse;
})(_response2['default']);

exports.SuperagentResponse = SuperagentResponse;

var SuperAgentResource = (function (_GenericResource) {
    _inherits(SuperAgentResource, _GenericResource);

    function SuperAgentResource() {
        _classCallCheck(this, SuperAgentResource);

        _get(Object.getPrototypeOf(SuperAgentResource.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(SuperAgentResource, [{
        key: 'wrapResponse',
        value: function wrapResponse(res) {
            return new SuperagentResponse(res);
        }
    }, {
        key: 'createRequest',
        value: function createRequest(method, url, query, data) {
            method = method.toLowerCase();

            var req = _superagent2['default'][method](url);

            if (query) {
                req = req.query(query);
            }

            if (data) {
                req = req.send(data);
            }

            return req;
        }
    }, {
        key: 'doRequest',
        value: function doRequest(req, resolve) {
            req.end(function (err, res) {
                resolve(res, err);
            });
        }
    }, {
        key: 'setHeader',
        value: function setHeader(req, key, value) {
            return req.set(key, value);
        }
    }]);

    return SuperAgentResource;
})(_base2['default']);

exports.SuperAgentResource = SuperAgentResource;


/*****************
 ** WEBPACK FOOTER
 ** ./~/tg-resources/dist/superagent/resource.js
 ** module id = 1055
 ** module chunks = 1
 **/